import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { PageLayout } from '@/ui/layouts/PageLayout'

export function OpportunitiesContainerSkeleton() {
  return (
    <PageLayout className="relative max-w-6xl gap-4 px-3 sm:gap-6">
      {/* Hero */}
      <div className="flex flex-col gap-1 sm:gap-4">
        <Skeleton className="h-10 w-64 sm:h-14 sm:w-80" />
        <Skeleton className="hidden h-5 w-[28rem] sm:block" />
        <div className="hidden items-center gap-2 sm:flex">
          <Skeleton className="h-4 w-24" />
          <div className="w-3.5" />
          <Skeleton className="h-4 w-24" />
          <div className="w-3.5" />
          <Skeleton className="h-4 w-24" />
        </div>
      </div>

      {/* Filter bar */}
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} className="h-8 w-16 rounded-full" />
          ))}
        </div>
        <div className="hidden items-center gap-1.5 sm:flex">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-7 w-16 rounded-full" />
          ))}
        </div>
      </div>

      {/* List skeleton */}
      <div className="flex flex-col gap-1">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="rounded-lg bg-white/[0.02]">
            {/* Desktop */}
            <div className="hidden grid-cols-[1fr_auto_1fr_0.6fr_1.6fr] items-center gap-2 px-4 py-3 md:grid">
              <div className="flex items-center gap-2.5">
                <Skeleton className="h-7 w-7 shrink-0 rounded-full" />
                <div className="flex flex-col gap-1.5">
                  <div className="flex items-center gap-2">
                    <Skeleton className="h-4 w-12" />
                    <Skeleton className="h-3.5 w-14" />
                  </div>
                  <Skeleton className="h-4 w-20 rounded-full" />
                </div>
              </div>
              <div className="w-3.5" />
              <div className="flex items-center gap-2.5">
                <Skeleton className="h-7 w-7 shrink-0 rounded-full" />
                <div className="flex flex-col gap-1.5">
                  <div className="flex items-center gap-2">
                    <Skeleton className="h-4 w-12" />
                    <Skeleton className="h-3.5 w-14" />
                  </div>
                  <Skeleton className="h-4 w-20 rounded-full" />
                </div>
              </div>
              <Skeleton className="mx-auto h-4 w-14" />
              <Skeleton className="ml-auto h-14 w-full rounded-md" />
            </div>
            {/* Mobile */}
            <div className="flex flex-col gap-2 p-3 md:hidden">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1.5">
                  <Skeleton className="h-4 w-4 rounded-full" />
                  <Skeleton className="h-3.5 w-10" />
                  <Skeleton className="h-3 w-12" />
                  <div className="w-2.5" />
                  <Skeleton className="h-4 w-4 rounded-full" />
                  <Skeleton className="h-3.5 w-10" />
                  <Skeleton className="h-3 w-12" />
                </div>
                <Skeleton className="h-4 w-14" />
              </div>
              <div className="flex items-center gap-1.5">
                <Skeleton className="h-4 w-20 rounded-full" />
                <div className="w-2" />
                <Skeleton className="h-4 w-20 rounded-full" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Info cards skeleton */}
      <div className="flex flex-col gap-6 lg:flex-row">
        <div className="flex flex-1 flex-col gap-3">
          <Skeleton className="h-5 w-32" />
          <div className="grid gap-3 sm:grid-cols-3">
            {[1, 2, 3].map((i) => (
              <Skeleton key={i} className="h-24 rounded-lg" />
            ))}
          </div>
        </div>
        <div className="flex w-full flex-col gap-3 lg:w-72">
          <Skeleton className="h-5 w-20" />
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-20 rounded-lg" />
          ))}
        </div>
      </div>
    </PageLayout>
  )
}
